"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlusDrawNodesFO = exports.SankeyPlusNodeFO = void 0;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_quill_1 = require("react-quill");
const react_2 = require("@chakra-ui/react");
const d3 = __importStar(require("d3"));
const react_quill_2 = __importDefault(require("react-quill"));
const SankeyUtils_1 = require("open-sankey/dist/configmenus/SankeyUtils");
const SankeyPlusUtils_1 = require("./SankeyPlusUtils");
const OpenSankey_1 = require("./import/OpenSankey");
const SankeyPlusNodeFO = (t, data, multi_selected_nodes, is_activated, d_setter_input_value, node_function) => {
    const [s_editor_content_fo_node, sEditorContentFoNode] = (0, react_1.useState)('');
    d_setter_input_value.r_setter_editor_content_fo_node.current = sEditorContentFoNode;
    // Create a custom size list of font-size
    const list_size = [];
    for (let i = 6; i <= 50; i++) {
        list_size.push(i + 'px');
    }
    const Size = react_quill_1.Quill.import('attributors/style/size');
    Size.whitelist = list_size;
    react_quill_1.Quill.register(Size, true);
    const modules = {
        toolbar: [
            [{ 'font': [] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'size': list_size }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'align': [] }],
            ['clean'],
        ],
    };
    const formats = ['font', 'size',
        'bold', 'italic', 'underline', 'strike', 'color', 'background',
        'list', 'bullet', 'align'
    ];
    const isQuill_invalid = multi_selected_nodes.current.length > 0 ? multi_selected_nodes.current[0].FO_content !== s_editor_content_fo_node : false;
    const value_of_key = (0, SankeyPlusUtils_1.OSPIsAllNodeNotLocalAttrSameValue)(data, multi_selected_nodes.current, ['has_FO', 'is_FO_raw']);
    //Create 2 editor :
    // - one in an editor when we can apply layout width buttons
    // - one with raw html in case the editor can't do exactly what we want
    const editor_fo = react_1.default.createElement(react_bootstrap_1.Form, { className: 'FO_zdt_editeur' },
        react_1.default.createElement(react_bootstrap_1.Form.Group, null,
            react_1.default.createElement(react_quill_2.default, { value: s_editor_content_fo_node, onChange: (evt, _, s) => {
                    if (s === 'user') {
                        sEditorContentFoNode(evt);
                    }
                }, onBlur: () => {
                    Object.values(data.nodes).filter(f => multi_selected_nodes.current.map(d => d.idNode).includes(f.idNode)).map(d => {
                        d.FO_content = s_editor_content_fo_node;
                    });
                    node_function.RedrawNodes(multi_selected_nodes.current);
                }, theme: "snow", modules: modules, formats: formats, readOnly: !is_activated ? true : !value_of_key['has_FO'][0], style: {
                    color: (!is_activated || !value_of_key['has_FO'][0]) ? '#666666' : '',
                    backgroundColor: (!is_activated || !value_of_key['has_FO'][0]) ? '#cccccc' : ''
                } })),
        react_1.default.createElement(react_bootstrap_1.Form.Control, { type: 'text', isInvalid: isQuill_invalid, style: { display: 'none' } }),
        react_1.default.createElement(react_bootstrap_1.Form.Control.Feedback, { type: 'invalid' }, t('MEP.onBlurNoEnter')));
    const editor_fo_raw = react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 5, style: {
            color: (!is_activated || !value_of_key['has_FO'][0]) ? '#666666' : '',
            backgroundColor: (!is_activated || !value_of_key['has_FO'][0]) ? '#cccccc' : ''
        }, disabled: !is_activated ? true : !value_of_key['has_FO'][0], value: multi_selected_nodes.current.length > 0 ? multi_selected_nodes.current[0].FO_content : '', onChange: (evt) => {
            Object.values(data.nodes).filter(f => multi_selected_nodes.current.map(d => d.idNode).includes(f.idNode)).map(d => {
                d.FO_content = evt.target.value;
            });
            node_function.RedrawNodes(multi_selected_nodes.current);
        } });
    return react_1.default.createElement(react_bootstrap_1.Tab, { key: "node_fo", eventKey: "node_fo", className: 'content_editon_elements', title: react_1.default.createElement(react_1.default.Fragment, null,
            t('Noeud.FO.FO'),
            (!is_activated) ?
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'textZoneDisabled', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'textZoneDisabled' },
                        t('Menu.sankeyPlusDisabled'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.Badge, { pill: true, bg: "white", style: { marginLeft: '5px', fontSize: '1.3em' } },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faLock, style: {
                                color: 'rgba(var(--bs-info-rgb), var(--bs-bg-opacity))'
                            } }))) :
                react_1.default.createElement(react_bootstrap_1.Badge, { pill: true, bg: "info", style: { marginLeft: '5px' } }, "Beta")) },
        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'foDisabled', placement: 'top', delay: 500, overlay: (!is_activated) ? (react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'foDisabled' },
                t('Menu.sankeyPlusDisabled'),
                " ")) : react_1.default.createElement(react_1.default.Fragment, null) },
            react_1.default.createElement(react_bootstrap_1.Row, null,
                react_1.default.createElement(react_bootstrap_1.Col, null,
                    react_1.default.createElement(react_2.Checkbox, { sx: (0, SankeyUtils_1.SmoothClasses)({}), iconColor: value_of_key['has_FO'][1] ? '#78C2AD' : 'white', isDisabled: !is_activated, isIndeterminate: value_of_key['has_FO'][1], isChecked: value_of_key['has_FO'][0], onChange: (evt) => {
                            Object.values(data.nodes).filter(f => multi_selected_nodes.current.map(d => d.idNode).includes(f.idNode))
                                .forEach(d => {
                                d.has_FO = evt.target.checked;
                            });
                            node_function.RedrawNodes(multi_selected_nodes.current);
                        } }, t('Noeud.foreign_object.Visibilité'))))),
        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'foRawDisabled', placement: 'top', delay: 500, overlay: (!is_activated) ? (react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'foRawDisabled' },
                t('Menu.sankeyPlusDisabled'),
                " ")) : react_1.default.createElement(react_1.default.Fragment, null) },
            react_1.default.createElement(react_bootstrap_1.Row, null,
                react_1.default.createElement(react_bootstrap_1.Col, null,
                    react_1.default.createElement(react_2.Checkbox, { sx: (0, SankeyUtils_1.SmoothClasses)({}), iconColor: value_of_key['is_FO_raw'][1] ? '#78C2AD' : 'white', isDisabled: !is_activated, isIndeterminate: value_of_key['is_FO_raw'][1], isChecked: value_of_key['is_FO_raw'][0], onChange: (evt) => {
                            Object.values(data.nodes).filter(f => multi_selected_nodes.current.map(d => d.idNode).includes(f.idNode))
                                .forEach(d => {
                                d.is_FO_raw = evt.target.checked;
                            });
                            node_function.RedrawNodes(multi_selected_nodes.current);
                        } }, t('Noeud.foreign_object.raw'))))),
        (multi_selected_nodes.current.length > 0) ?
            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'foContentDisabled', placement: 'top', delay: 500, overlay: (!is_activated) ?
                    (react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'foContentDisabled' },
                        t('Menu.sankeyPlusDisabled'),
                        " ")) :
                    (!value_of_key['has_FO'][0]) ? react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'foNotVisible' }, t('Noeud.foreign_object.not_activated')) : react_1.default.createElement(react_1.default.Fragment, null) },
                react_1.default.createElement(react_bootstrap_1.Form, { className: 'FO_node_editeur' },
                    react_1.default.createElement(react_bootstrap_1.Form.Group, null, multi_selected_nodes.current[0].is_FO_raw ? editor_fo_raw : editor_fo)))
            : react_1.default.createElement(react_1.default.Fragment, null));
};
exports.SankeyPlusNodeFO = SankeyPlusNodeFO;
const PlusDrawNodesFO = (data, display_nodes, dict_variable_elements_selected, NodeTooltipsContent, GetLinkValue, trad) => {
    const { ref_getter_mode_selection } = dict_variable_elements_selected;
    const node_mouse_over = (data, t, event, d) => {
        d3.select(t).attr('cursor', (ref_getter_mode_selection.current === 's') ? 'pointer' : 'unset');
        if ((0, OpenSankey_1.NodeDisplayed)(data, d) && (window.SankeyToolsStatic || event.shiftKey)) {
            const sankeyTooltip = d3.select('.sankey-tooltip');
            sankeyTooltip
                .style('opacity', 1)
                .html(NodeTooltipsContent(data, display_nodes, d, GetLinkValue, trad));
        }
    };
    const node_mouse_move = (event, d) => {
        if (((0, OpenSankey_1.NodeDisplayed)(data, d)) && (window.SankeyToolsStatic || event.shiftKey)) {
            const sankeyTooltip = d3.select('.sankey-tooltip');
            const h_tooltip = Number(sankeyTooltip.style('height').replace('px', ''));
            let pos_tooltip_y = event.clientY;
            const size_browser = window.innerHeight;
            pos_tooltip_y = ((h_tooltip + pos_tooltip_y) > size_browser) ? event.pageY + (size_browser - (pos_tooltip_y + h_tooltip)) - 5 : event.pageY;
            const w_tooltip = Number(sankeyTooltip.style('width').replace('px', ''));
            let pos_tooltip_x = event.clientX;
            const size_browser_w = window.innerWidth;
            pos_tooltip_x = ((w_tooltip + pos_tooltip_x) > size_browser_w) ? event.pageX - w_tooltip - 30 : event.pageX + 30;
            sankeyTooltip
                .style('top', pos_tooltip_y + 'px')
                .style('left', pos_tooltip_x + 'px');
        }
    };
    const add_nodes_fo = () => {
        //----------------ICON-----------------
        // Add icon to node (if there is one associated to it)
        // then apply selected parameter
        const sankeyTooltip = d3.select('div.sankey-tooltip');
        const ggg_nodes = d3.selectAll('.ggg_nodes');
        ggg_nodes.filter((d) => {
            return d.has_FO;
        }).append('foreignObject')
            .attr('width', (n) => +d3.select(' .opensankey #shape_' + n.idNode).attr('width'))
            .attr('height', (n) => +d3.select(' .opensankey #shape_' + n.idNode).attr('height'))
            .attr('id', (d) => d.idNode + '_fo')
            .on('mouseover', function (event, d) {
            node_mouse_over(data, this, event, d);
        })
            .on('mousemove', function (event, d) {
            node_mouse_move(event, d);
        })
            .on('mouseout', function () {
            sankeyTooltip.style('opacity', 0);
        })
            .append('xhtml:div')
            .attr('class', 'ql-editor')
            .html((d) => d.FO_content);
    };
    add_nodes_fo();
};
exports.PlusDrawNodesFO = PlusDrawNodesFO;
